import React from "react";
import useSWR from "swr";
import { fetcherWithToken } from "./fetcher-with-token";
import { CardVagas } from "./components/card-vagas";
import { Tabs, Text } from "@vagastec/ensemble-core";
import {
  containerHeader,
  containerCards,
  listCardsVagasStyle,
  ulListCardsStyle,
  containerErrorCards,
} from "./step-0.css";
import { IconeError } from "./icons/icone-error";
import { Alert } from "./components/alert";
import { StatusMessage } from "./components/status-message";
import CardLoader from "./components/card-loader";
import { initialFormState } from ".";
import { vagasLinkStyle } from "./vaga-criada.css";
import { defineMessage, FormattedMessage, useIntl } from "react-intl";
import { InfoNovidades } from "./components/info-novidades";
import { containerSalario, infoIconContainer } from "./step-1.css";
import { InfoIcon } from "./icons/info-icon";
import { alertStyle, alertVariants } from "./components/alert.css";
import { vars } from "./theme.css";
import { IconWarning } from "./icons/icon-warning";

// Pode criar vaga
// dir_editar_vaga: true

// Pode criar vaga exclusivamente a partir de modelo:
// dir_editar_vagarestrmod: true

// Pode criar exclusivamente a partir de modelo e recorrente:
// dir_editar_vagarestrmodpub: true

// Pode criar exclusivamente a partir de requisições:
// dir_editar_vagarestrreqvaga: true

// Pode exclusivamente alterar vaga:
// dir_alterar_vaga	true e os demais false

export function Step0({ formState, setFormState }) {
  const intl = useIntl();
  const permissoes = formState.painelData?.funcionario.permissoes;

  const { data: vagasRecorrentesData, error: vagasRecorrentesError } = useSWR(
    permissoes?.dir_editar_vaga ||
      permissoes?.dir_editar_vagarestrmodpub ||
      permissoes?.dir_alterar_vaga
      ? `${process.env.HESTIA}/cargos_de_referencia?vaga_modelo=false&quantidade=11`
      : null,
    fetcherWithToken
  );

  const { data: vagasModeloData, error: vagasModeloError } = useSWR(
    permissoes?.dir_editar_vaga ||
      permissoes?.dir_editar_vagarestrmodpub ||
      permissoes?.dir_alterar_vaga ||
      permissoes?.dir_editar_vagarestrmod
      ? `${process.env.HESTIA}/cargos_de_referencia?vaga_modelo=true`
      : null,
    fetcherWithToken
  );

  const CardSkeleton = () => (
    <ul aria-label="Vagas-modelo" className={ulListCardsStyle}>
      <li className={listCardsVagasStyle}>
        <CardLoader />
      </li>
      <li className={listCardsVagasStyle}>
        <CardLoader />
      </li>
      <li className={listCardsVagasStyle}>
        <CardLoader />
      </li>
      <li className={listCardsVagasStyle}>
        <CardLoader />
      </li>
      <li className={listCardsVagasStyle}>
        <CardLoader />
      </li>
      <li className={listCardsVagasStyle}>
        <CardLoader />
      </li>
    </ul>
  );

  function renderVagasRecorrentes(exibirCardNovaVaga) {
    if (vagasRecorrentesError) {
      return (
        <div className={containerErrorCards}>
          <Alert variant="error">
            <IconeError />
            <Text size="sm">
              <FormattedMessage
                id="step0.erroAoCarregarVagasRecorrentes"
                defaultMessage="Não conseguimos carregar suas vagas. Tente novamente."
              />
            </Text>
          </Alert>
        </div>
      );
    }
    return !vagasRecorrentesData ? (
      <CardSkeleton />
    ) : (
      <ul aria-label="Cargos recorrentes" className={ulListCardsStyle}>
        {exibirCardNovaVaga ? (
          <li className={listCardsVagasStyle} key={0}>
            <CardVagas
              linkTo="/novo-processo"
              label={intl.formatMessage(
                defineMessage({
                  id: "step0.novaVaga",
                  defaultMessage: "Nova vaga",
                })
              )}
              withIcon
              onClick={() =>
                setFormState((prev) => ({
                  ...initialFormState,
                  painelData: prev.painelData,
                }))
              }
            />
          </li>
        ) : null}
        {vagasRecorrentesData.map((v) => (
          <li className={listCardsVagasStyle} key={v.id}>
            <CardVagas
              linkTo={`/novo-processo?fromId=${v.id}`}
              label={v.label}
            />
          </li>
        ))}
      </ul>
    );
  }

  function renderVagasModelo() {
    if (vagasModeloError) {
      return (
        <div className={containerErrorCards}>
          <Alert variant="error">
            <IconeError />
            <Text size="sm">
              <FormattedMessage
                id="step0.erroAoCarregarVagasModelo"
                defaultMessage="Não conseguimos carregar suas vagas. Tente novamente."
              />
            </Text>
          </Alert>
        </div>
      );
    }
    return !vagasModeloData ? (
      <ul aria-label="Vagas-modelo" className={ulListCardsStyle}>
        <li className={listCardsVagasStyle}>
          <CardLoader />
        </li>
        <li className={listCardsVagasStyle}>
          <CardLoader />
        </li>
        <li className={listCardsVagasStyle}>
          <CardLoader />
        </li>
        <li className={listCardsVagasStyle}>
          <CardLoader />
        </li>
        <li className={listCardsVagasStyle}>
          <CardLoader />
        </li>
        <li className={listCardsVagasStyle}>
          <CardLoader />
        </li>
      </ul>
    ) : (
      <ul aria-label="Vagas-modelo" className={ulListCardsStyle}>
        {vagasModeloData?.length ? (
          vagasModeloData.map((v) => (
            <li className={listCardsVagasStyle} key={v.id}>
              <CardVagas
                linkTo={`/novo-processo?fromId=${v.id}`}
                label={v.label}
                description={
                  v.localizacao && v.localizacao.cidade
                    ? `${v.localizacao?.cidade} / ${v.localizacao?.estado_short}`
                    : ``
                }
              />
            </li>
          ))
        ) : (
          <>
            <StatusMessage>
              <Text size="rg" weight={600} as="p">
                <FormattedMessage
                  id="step0.semVagaModelo"
                  defaultMessage="Você ainda não tem vaga-modelo para utilizar!"
                />
              </Text>

              {formState.painelData?.funcionario.admin ? (
                <a
                  href={`${process.env.GLOBAL_URL}/vagas/processos-seletivos/nova-vaga-modelo`}
                  className={vagasLinkStyle}
                >
                  <FormattedMessage
                    id="step0.criarVagaModelo"
                    defaultMessage="Criar vaga-modelo"
                  />
                </a>
              ) : null}
            </StatusMessage>
          </>
        )}
      </ul>
    );
  }

  function renderVagasSegundoPermissoes() {
    if (
      permissoes?.dir_editar_vaga === true &&
      permissoes?.dir_editar_vagarestrmod === false &&
      permissoes?.dir_editar_vagarestrmodpub === false
    ) {
      return (
        <Tabs activeTabIndex={0}>
          <Tabs.Item
            label={
              <FormattedMessage
                id="step0.tabRecorrentes"
                defaultMessage="Recorrentes"
              />
            }
          >
            {renderVagasRecorrentes(true)}
          </Tabs.Item>
          <Tabs.Item
            label={
              <FormattedMessage
                id="step0.tabModelo"
                defaultMessage="Vagas-modelo"
              />
            }
          >
            {renderVagasModelo()}
          </Tabs.Item>
        </Tabs>
      );
    }

    if (
      permissoes?.dir_editar_vaga === false &&
      permissoes?.dir_editar_vagarestrmod === false &&
      permissoes?.dir_editar_vagarestrmodpub === false &&
      permissoes?.dir_editar_vagarestrreqvaga === false
    ) {
      return (
        <StatusMessage>
          <Text size="rg" weight={600} as="p">
            <FormattedMessage
              id="step0.semPermissao"
              defaultMessage="Você não tem permissão para criar vaga. Contate o seu admin."
            />
          </Text>
        </StatusMessage>
      );
    }

    if (
      permissoes?.dir_editar_vagarestrreqvaga === true &&
      permissoes?.dir_editar_vagarestrmod === false &&
      permissoes?.dir_editar_vagarestrmodpub === false
    ) {
      return (
        <StatusMessage>
          <Text size="rg" weight={600} as="p">
            <FormattedMessage
              id="step0.permissaoApenasRequisicao"
              defaultMessage=" Você só tem permissão para criar vaga a partir de requisição."
            />
          </Text>
        </StatusMessage>
      );
    }

    if (
      permissoes?.dir_editar_vagarestrmod === true &&
      permissoes?.dir_editar_vagarestrmodpub === false
    ) {
      return (
        <Tabs activeTabIndex={0}>
          <Tabs.Item label="Recorrentes">
            <StatusMessage>
              <Text size="rg" weight={600} as="p">
                <FormattedMessage
                  id="step0.permissaoApenasModelo"
                  defaultMessage="Você só tem permissão para criar vaga a partir de um modelo."
                />
              </Text>
            </StatusMessage>
          </Tabs.Item>
          <Tabs.Item label="Vagas-modelo">{renderVagasModelo()}</Tabs.Item>
        </Tabs>
      );
    }

    if (permissoes?.dir_editar_vagarestrmodpub === true) {
      return (
        <Tabs activeTabIndex={0}>
          <Tabs.Item
            label={
              <FormattedMessage
                id="step0.vagasRecorrentes"
                defaultMessage="Recorrentes"
                description="Referente a vagas recorrentes"
              />
            }
          >
            {renderVagasRecorrentes()}
          </Tabs.Item>
          <Tabs.Item
            label={
              <FormattedMessage
                id="step0.vagasModelo"
                defaultMessage="Vagas-modelo"
              />
            }
          >
            {renderVagasModelo()}
          </Tabs.Item>
        </Tabs>
      );
    }
  }

  return (
    <>
      <InfoNovidades />
      <div className={containerCards}>
        <div className={containerHeader}>
          <Text size="xl" weight={600} as="h2">
            <FormattedMessage
              id="step0.titulo"
              defaultMessage="Qual profissional você gostaria de contratar?"
            />
          </Text>

          <Text as="p">
            <FormattedMessage
              id="step0.subtitulo"
              defaultMessage="Escolha um dos cargos recorrentes para facilitar a abertura do seu
            processo seletivo!"
            />
          </Text>
        </div>
        <section>
          {formState.painelData ? (
            renderVagasSegundoPermissoes()
          ) : (
            <>
              <Tabs activeTabIndex={0}>
                <Tabs.Item
                  disabled
                  label={
                    <FormattedMessage
                      id="step0.vagasRecorrentes"
                      defaultMessage="Recorrentes"
                      description="Referente a vagas recorrentes"
                    />
                  }
                ></Tabs.Item>
                <Tabs.Item
                  disabled
                  label={
                    <FormattedMessage
                      id="step0.vagasModelo"
                      defaultMessage="Vagas-modelo"
                    />
                  }
                ></Tabs.Item>
              </Tabs>
              <CardSkeleton />
            </>
          )}
        </section>

        {formState.painelData?.cliente.vagas_redes === true ? (
          <>
            <Alert variant="info">
              <div className={infoIconContainer}>
                <IconWarning fill={vars.color.brand} />
              </div>
              <Text size="sm" as="p">
                <FormattedMessage
                  id="infoTransicaoAsp.textoRedes"
                  defaultMessage="<a></a> para voltar para a versão anterior da publicação"
                  values={{
                    a: (chunks) => (
                      <a
                        href={`${process.env.GLOBAL_URL}/move-to/transicao_ruby_asp_criacao_de_vaga`}
                        target="_self"
                        style={{
                          color: vars.color.brand,
                          textDecoration: "none",
                        }}
                      >
                        {chunks}
                        <b>
                          <FormattedMessage
                            id="infoTransicaoAsp.cliqueAqui"
                            defaultMessage="Clique aqui"
                          />
                        </b>
                      </a>
                    ),
                  }}
                />
              </Text>
            </Alert>
          </>
        ) : null}

        {formState.painelData?.cliente.vagas_redes === false ? (
          <>
            <Alert variant="info">
              <div className={infoIconContainer}>
                <IconWarning fill={vars.color.brand} />
              </div>{" "}
              <Text size="sm" as="p">
                <FormattedMessage
                  id="infoTransicaoAsp.textoDataLimite"
                  defaultMessage="Você pode <a></a> até 16 de agosto de 2022"
                  values={{
                    a: (chunks) => (
                      <a
                        href={`${process.env.GLOBAL_URL}/move-to/transicao_ruby_asp_criacao_de_vaga`}
                        target="_self"
                        style={{
                          color: vars.color.brand,
                          textDecoration: "none",
                        }}
                      >
                        {chunks}
                        <b>
                          <FormattedMessage
                            id="infoTransicaoAsp.link"
                            defaultMessage="voltar para a versão anterior da publicação de vaga"
                          />
                        </b>
                      </a>
                    ),
                  }}
                />
              </Text>
            </Alert>
          </>
        ) : null}
      </div>
    </>
  );
}
